import React from 'react';

const alertStyles = {
  critical: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    icon: 'text-red-500',
    title: 'text-red-800',
    text: 'text-red-600',
  },
  warning: {
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    icon: 'text-amber-500',
    title: 'text-amber-800',
    text: 'text-amber-600',
  },
  info: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    icon: 'text-blue-500',
    title: 'text-blue-800',
    text: 'text-blue-600',
  },
};

export default function AlertPanel({ alerts }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200">
      <div className="px-6 py-4 border-b border-slate-200">
        <h3 className="text-lg font-semibold text-slate-800">Alertes récentes</h3>
      </div>

      <div className="p-4 space-y-3">
        {alerts.length === 0 ? (
          <p className="text-sm text-slate-500 text-center py-4">
            Aucune alerte en cours
          </p>
        ) : (
          alerts.map((alert) => {
            const style = alertStyles[alert.type] || alertStyles.info;
            return (
              <div
                key={alert.id}
                className={`${style.bg} ${style.border} border rounded-lg p-4`}
              >
                <div className="flex items-start gap-3">
                  <svg className={`w-5 h-5 ${style.icon} mt-0.5`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                  <div className="flex-1">
                    <p className={`text-sm font-medium ${style.title}`}>
                      {alert.title}
                    </p>
                    <p className={`text-sm ${style.text} mt-1`}>
                      {alert.message}
                    </p>
                    <p className="text-xs text-slate-400 mt-2">
                      {alert.date}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}